// OPS-32: helpers puros del estado del mapa en vivo (sin React ni red), para
// poder testearlos aparte del componente.

export const DEMO_AMOUNTS = [10, 60, 150, 400, 1200, 5000];
export const DEMO_MIN_DELAY_MS = 1500;
export const DEMO_MAX_DELAY_MS = 3000;

// Ultimas `limit` transferencias por updated_at desc. Una fila que vuelve en
// un poll posterior (cambio de estado) reemplaza a la anterior por id.
export function mergeRecent(prev, txs, limit = 5) {
  const byId = new Map(prev.map((t) => [t.id, t]));
  for (const tx of txs) byId.set(tx.id, tx);
  const time = (t) => {
    const ms = Date.parse(t.updated_at);
    return Number.isFinite(ms) ? ms : 0;
  };
  return [...byId.values()].sort((a, b) => time(b) - time(a)).slice(0, limit);
}

// Conjunto acumulativo de codigos de pais: union de lo ya visto, de los
// `countries` del server y de origen/destino de cada transaccion. Devuelve el
// mismo Set si no crecio, para no recalcular el layout sin necesidad.
export function unionCodes(prev, countries, txs) {
  const next = new Set(prev);
  for (const c of countries || []) if (c) next.add(c);
  for (const tx of txs || []) {
    if (tx.source_country) next.add(tx.source_country);
    if (tx.target_country) next.add(tx.target_country);
  }
  return next.size === prev.size ? prev : next;
}

// Acota el mapa id -> status descartando las entradas mas viejas (orden de
// insercion), para que una pestaña abierta todo el dia no crezca sin limite.
export function capSeen(seen, max) {
  if (seen.size <= max) return seen;
  const next = new Map(seen);
  let drop = next.size - max;
  for (const key of next.keys()) {
    if (drop <= 0) break;
    next.delete(key);
    drop -= 1;
  }
  return next;
}

// Transferencia aleatoria del modo demo entre dos nodos distintos. Nace en
// `executing`; `finalStatus` es el estado al que resuelve al llegar.
export function pickDemoTransfer(codes, seq, rand = Math.random, now = Date.now()) {
  if (!codes || codes.length < 2) return null;
  const si = Math.floor(rand() * codes.length) % codes.length;
  let ti = Math.floor(rand() * (codes.length - 1)) % (codes.length - 1);
  if (ti >= si) ti += 1;
  const amount = DEMO_AMOUNTS[Math.floor(rand() * DEMO_AMOUNTS.length) % DEMO_AMOUNTS.length];
  const points = rand() < 0.2;
  const r = rand();
  const finalStatus = r < 0.85 ? "completed" : r < 0.95 ? "failed" : "reversed";
  return {
    tx: {
      id: `demo-${now}-${seq}`,
      source_country: codes[si],
      target_country: codes[ti],
      amount_usd: amount,
      unit: points ? "ZUS" : "USD",
      kind: points ? "points" : "fiat",
      status: "executing",
      updated_at: new Date(now).toISOString(),
    },
    finalStatus,
  };
}

// Cursor `since` del proximo poll: server_time menos un solapamiento. El
// backend fija updated_at = NOW(), que en Postgres es la hora de INICIO de la
// transaccion, no la del commit; una fila que commitea despues de que el poll
// tomo su server_time puede tener updated_at anterior a ese server_time y se
// perderia con since = server_time. Ademas el reloj de la app (server_time) y
// el de Postgres pueden diferir. Las filas repetidas por el solapamiento las
// absorben diffTransactions (mismo estado no anima) y mergeRecent (por id).
// Nunca retrocede respecto del cursor ya enviado.
export function nextCursor(prevSent, serverTime, overlapMs) {
  const ms = Date.parse(serverTime);
  if (!Number.isFinite(ms)) return prevSent;
  const candidate = ms - overlapMs;
  const prevMs = prevSent ? Date.parse(prevSent) : NaN;
  if (Number.isFinite(prevMs) && prevMs >= candidate) return prevSent;
  return new Date(candidate).toISOString();
}

// Si la pestana estuvo oculta mas que el umbral, el proximo poll vuelve a ser
// linea base silenciosa (sin viajes) en lugar de animar todo lo acumulado.
export function shouldRebaseline(hiddenMs, thresholdMs) {
  return Number.isFinite(hiddenMs) && hiddenMs > thresholdMs;
}

export function demoDelay(rand = Math.random) {
  return DEMO_MIN_DELAY_MS + rand() * (DEMO_MAX_DELAY_MS - DEMO_MIN_DELAY_MS);
}
